export const socialMediaAgreement =
    'Zgadzam się na udostępnianie wizerunku dziecka na portalach społecznościowych:';
